<div
  *ngIf="validIndices.length"
  class="mat-elevation-z1 bg-color-white u-padding-16 u-marginBottom-16"
>
  <p class="text-subtitle-1 u-marginBottom-16">
    <span i18n="@@profileView.completionWidget.subtitle" class="color-grey"
      >Profile strength:
    </span>
    <b
      i18n="@@profileView.completionWidget.profileStrength.text"
      >{profileStrengthText, select, other {{{ profileStrengthText }}}
    }</b>
  </p>
  <div
    fxLayout="row"
    fxLayoutAlign="center center"
    class="u-position-relative u-marginBottom-16"
  >
    <app-segmented-spinner
      class="u-display-block"
      [completedSteps]="profileStrengthCount"
      [segmentsCount]="stepsToCompletion"
    >
    </app-segmented-spinner>
  </div>
  <mat-tab-group
    [selectedIndex]="widgetIndex"
    class="mat-tab-group-hide-headers"
    mat-stretch-tabs="false"
  >
    <mat-tab *ngFor="let config of widgetConfigs">
      <app-profile-completion-widget
        [group]="config.group"
        class="u-display-block bg-color-white u-card"
        [ngStyle]="{ zIndex: 0 }"
        [title]="config.title"
        [description]="config.description"
        [profileStrengthText]="profileStrengthText"
        [profileStrengthCount]="profileStrengthCount"
        [stepsToCompletion]="stepsToCompletion"
        [ctaText]="config.ctaText"
        [canSkip]="1 < validIndices.length"
        (addProfileInformation)="config.addProfileInformation()"
        (skip)="config.skip()"
      >
      </app-profile-completion-widget>
    </mat-tab>
  </mat-tab-group>
</div>
